import { CategoryDto } from "../category/category.dto";
import { DtoInclude, DtoIncludeNumber, DtoRef } from "../../../core/store/dto/dto";

export class JobStatusDto extends CategoryDto {
    @DtoInclude
    closed: boolean;
    @DtoIncludeNumber
    timeout: number;
    @DtoRef
    timeoutStatus: string;
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/job-status/job-status.dto.ts